import { Pipe, PipeTransform } from '@angular/core';

import { PackagingFormat } from '@mtna/rds-packaging-ui';

/**
 * Determines if a given PackagingFormat ID exists in the selected array
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsIsFormatSelected'
})
export class RdsIsFormatSelectedPipe implements PipeTransform {
  /**
   * Determines if a given PackagingFormat ID exists in the selected array
   *
   * @param value `PackagingFormat` ID to check
   * @param selected array of selected `PackagingFormat`
   * @returns Whether the given id exists in the selected array
   */
  transform(value: string, selected: Array<PackagingFormat>): boolean {
    return !selected ? false : selected.some(f => f.id === value);
  }
}
